import _classCallCheck from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component, PropTypes } from 'react';
import styles from '../../../build/styles';

var Radio =
/*#__PURE__*/
function (_Component) {
  _inherits(Radio, _Component);

  function Radio() {
    _classCallCheck(this, Radio);

    return _possibleConstructorReturn(this, _getPrototypeOf(Radio).apply(this, arguments));
  }

  _createClass(Radio, [{
    key: "createControlClassName",
    value: function createControlClassName() {
      return [styles.control, this.props.className].join(' ').trim();
    }
  }, {
    key: "renderForm",
    value: function renderForm() {
      return this.props.data.map(function (d, i) {
        return React.createElement('label', {
          className: styles.radio,
          key: i
        }, React.createElement('input', _extends({}, d.inputProps, {
          type: 'radio'
        })), d.label);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement('p', {
        className: this.createControlClassName(),
        style: this.props.style
      }, this.renderForm());
    }
  }]);

  return Radio;
}(Component);

export { Radio as default };
Radio.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  data: PropTypes.array
};
Radio.defaultProps = {
  data: [],
  style: {},
  className: ''
};